var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoVendorManagementEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0a3 3 0 0 1 3 3v17h15a3 3 0 0 1 3 3v38a3 3 0 0 1-3 3h-34a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h16zm42 0a3 3 0 0 1 3 3v48.2L54.5 64l-10-12.8V3a3 3 0 0 1 3-3h14zm-41 42h-18v19a1 1 0 0 0 .883.993L3.5 62h17V42zm17-20h-15v40h15a1 1 0 0 0 .993-.883L38.5 61V23a1 1 0 0 0-.883-.993L37.5 22zm24.616 29H46.882l7.618 9.75L62.116 51zm.384-37h-16v35h16V14zm-42 8h-18v18h18V22zm-1-20h-16a1 1 0 0 0-.993.883L2.5 3v17h18V3a1 1 0 0 0-.883-.993L19.5 2zm42 0h-14a1 1 0 0 0-.993.883L46.5 3v9h16V3a1 1 0 0 0-.883-.993L61.5 2z",
    fill: "#888FA9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVendorManagementEmpty);
export default __webpack_public_path__ + "static/media/ico-vendor-management-empty.59ef450134b99be8f5a963e284792433.svg";
export { ForwardRef as ReactComponent };